import React from 'react';
import { Route, Link, BrowserRouter as Router } from "react-router-dom"
import BlockedDime from './BlockedDime'
import RateButton from './RateButton'
import Image from 'react-image-resizer';
var base64 = require('base-64');


let url = "https://p10-profile-image.s3.amazonaws.com"

export let categoryName = '';
export let dimeId = '';
export let pImage = '';

//const Card = ({name, email, id,setTest}) => {
	class BlockedDimeCard extends React.Component{

	constructor() {
    super();
    this.state = {
      user: {
        uid: '',
        uname: ''

      }
    }
  }

    onSubmitSignIn = () => {
    this.props.onRouteChange('home');

  }



//<img alt = 'robots' src = {`https://robohash.org/${id}?200x200` }/> 
  

	render(){
	let { category, rating, image_key, dime_id, rating_count} = this.props;
	if(rating == null){
		rating = 0
	}
	if(rating_count == null){
		rating_count = 0
	}
	categoryName = category;
	dimeId = dime_id;

	//uid = id;
	this.state.user.uname = this.props.first_name;
	pImage = image_key;
	let imageURL = `${url}/${pImage}`


	return (
		<div className = 'bg-light-blue dib br3 pa3 ma2 grow bw2 shadow-5'>
		<Image src= {imageURL} alt="" width={250} height={250} mode='cover' />
			
			<div>

			<h2> {category} </h2>
			<p>p10 rating: {rating.toFixed(1)}</p>
			<p>Total ratings: {rating_count}</p>
			<BlockedDime setTest={ this.props.setTest}  Name ={category} Id={dime_id}/>

			</div>
		</div>
		);
}
}

export default BlockedDimeCard;